import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import {AuthService} from '../services/auth.service'
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
  providers:[AuthService]
})
export class LoginComponent implements OnInit {

  user: any = {};
  constructor(private Auth: AuthService,private router: Router) { }

  ngOnInit(): void {
  }

  // login(){
  //   this.router.navigate(['/app/dash']);
  // }

  login() {
    //this.loading = true;

    var username = this.user.username;
    var password = this.user.password;
    var scode = this.user.scode;
    // var fyear = this.fyear;
    var userData ={username:username, password:password,scode:scode};
    console.log(userData);
    this.Auth.login(userData)
        .subscribe(
            data => {
                console.log(data);
                if(data==true){
                    localStorage.setItem('ldcnt', '1');
                    this.router.navigate(['/app/dash']);
                }else{
                    alert("Invalid login credentials or User data not found.");
                }
                 
            },
            error => {
                console.log(error);
                //this.loading = false;
            });
}


logout()
{
    this.Auth.logout();

this.router.navigate(['/login']);

}

}
